
    <div class="ui-g-12 dashboard card card-w-title">
      <div class="ui-g-12 ui-grid-row">
        {{'products.select_product' | translate}}
      </div>
      <form (ngSubmit)="this.onNextClick()" #categoryChoiceForm="ngForm">
        <div class="ui-g-12 ui-grid-row">
          <p-dropdown [style]="{'width':'100%'}" [filter]="true" filterBy="label" [options]="this.categories" (onChange)="this.onChangeCategory($event)"></p-dropdown>
        </div>
        <div class="ui-g-12 ui-grid-row">
          <p-treeTable *ngIf="this.selectedCategory != null" (onNodeSelect)="this.onNextClick($event)" [value]="this.srvStore.subsectors_tree" selectionMode="{{selectionMode}}"
                       [(selection)]="this.selectedSectors">
            <ng-template pTemplate="header">
              <tr>
                <th>{{'products.category_id' | translate}}</th>
                <th>{{'products.category_description' | translate}}</th>
              </tr>
            </ng-template>
            <ng-template pTemplate="body" let-rowNode let-rowData="rowData">
              <tr [ttSelectableRow]="rowNode">
                <td>
                  <p-treeTableToggler [rowNode]="rowNode"><i class="fa fa-caret-right"></i></p-treeTableToggler>
                  {{ nicelyIdTreeView(rowData.id) }}
                </td>
                <td>{{rowData.description}}</td>
              </tr>
            </ng-template>
          </p-treeTable>
        </div>
      </form>
    </div>
  


// WEBPACK FOOTER //
// ./src/app/views/products/category-choice.component.ts.CategoryChoiceComponent.html